import React from 'react'

const FullPageSpinner: React.FC = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ height: '100%', minHeight: '100vh' }}>
            <div
                className='spinner-border'
                role='status'
                style={{ width: '5rem', height: '5rem', borderWidth: '0.3rem' }}
            >
                <span className='visually-hidden'>Loading...</span>
            </div>
        </div>
    )
}

export default FullPageSpinner